import { ref, Ref } from "vue";
import axios from "axios";
import { debug as d } from "debug";
import { csContext } from "../services/cs-context";
import { CmsPathwaysRelationship } from "../services/cms/cms-type-definitions";
import { TeamPathwayApiModel } from "../api-models";
import cms from "../services/cms/cms";

const debug = d("cs.useSelectTeamPathway");

export type UseSelectTeamPathwayResponse = {
  error: Ref<string>;
  success: Ref<boolean>;
};

async function useSelectTeamPathwayFromLevel(
  teamPathway: CmsPathwaysRelationship,
  teamId: string,
  deadline: string,
): Promise<UseSelectTeamPathwayResponse> {
  const error = ref("");
  const success = ref(false);

  const outcome = await cms.getByUid("cms-goal", teamPathway.data?.goal_relationship?.uid ?? "");

  const selectedPathwayApiModel: TeamPathwayApiModel = {
    triggeringUserId: csContext.user.id,
    cmsPathwayId: teamPathway.id,
    cmsPathwayUid: teamPathway.uid,
    cmsPathwayTitle: cms.asText(teamPathway.data?.title),
    cmsOutcomeTitle: cms.asText(outcome?.data?.full_title),
    cmsOutcomeUid: outcome?.uid ?? "",
    cmsOutcomeId: outcome?.id ?? "",
    deadline,
    isCurrent: true,
    completed: false,
  };

  try {
    const response = await axios.post(`/api/teampathway/${teamId}`, selectedPathwayApiModel);
    success.value = response.status === 200;
  } catch (e) {
    debug("Error initiating pathway", e);
    error.value = "There was an error initiating this pathway";
  }

  return { error, success };
}
export default useSelectTeamPathwayFromLevel;
